import { type Booking } from '../../models/Scheduling'

export type SchedulingTabKey = 'requests' | 'suggested' | 'waiting' | 'scheduled'

export const SCHEDULING_TAB_KEYS: SchedulingTabKey[] = ['requests', 'suggested', 'waiting', 'scheduled']

export interface BookingMonthGroup {
  monthKey: string
  monthLabel: string
  bookings: Booking[]
}

export const getUpcomingBookings = (bookings: Booking[], now: Date = new Date()): Booking[] =>
  bookings.filter((booking) => {
    const endsAt = booking.end ?? booking.start
    return endsAt ? new Date(endsAt).getTime() >= now.getTime() : false
  })

const bookingSortTime = (booking: Booking): number => (booking.start ? new Date(booking.start).getTime() : Number.MAX_SAFE_INTEGER)

// Groups scheduled bookings into ascending month buckets with "APRIL 2026"-style labels
export const groupBookingsByMonth = (bookings: Booking[]): BookingMonthGroup[] => {
  const sorted = [...bookings].sort((a, b) => bookingSortTime(a) - bookingSortTime(b))
  const groups: BookingMonthGroup[] = []
  sorted.forEach((booking) => {
    if (!booking.start) {
      return
    }
    const startAt = new Date(booking.start)
    const monthKey = `${startAt.getFullYear()}-${String(startAt.getMonth() + 1).padStart(2, '0')}`
    const lastGroup = groups[groups.length - 1]
    if (lastGroup && lastGroup.monthKey === monthKey) {
      lastGroup.bookings.push(booking)
    } else {
      groups.push({
        monthKey,
        monthLabel: startAt.toLocaleDateString('en-US', { month: 'long', year: 'numeric' }).toUpperCase(),
        bookings: [booking],
      })
    }
  })
  return groups
}
